"use strict";

var _taggedTemplateLiteral = require("/opt/build/repo/node_modules/@babel/runtime/helpers/taggedTemplateLiteral.js");

var _toConsumableArray = require("/opt/build/repo/node_modules/@babel/runtime/helpers/toConsumableArray.js");

var _defineProperty = require("/opt/build/repo/node_modules/@babel/runtime/helpers/defineProperty.js");

var _createClass = require("/opt/build/repo/node_modules/@babel/runtime/helpers/createClass.js");

var _inherits = require("/opt/build/repo/node_modules/@babel/runtime/helpers/inherits.js");

var _possibleConstructorReturn = require("/opt/build/repo/node_modules/@babel/runtime/helpers/possibleConstructorReturn.js");

var _getPrototypeOf = require("/opt/build/repo/node_modules/@babel/runtime/helpers/getPrototypeOf.js");

var _classCallCheck = require("/opt/build/repo/node_modules/@babel/runtime/helpers/classCallCheck.js");

var _templateObject, _templateObject2;

function _createSuper(Derived) { var hasNativeReflectConstruct = _isNativeReflectConstruct(); return function _createSuperInternal() { var Super = _getPrototypeOf(Derived), result; if (hasNativeReflectConstruct) { var NewTarget = _getPrototypeOf(this).constructor; result = Reflect.construct(Super, arguments, NewTarget); } else { result = Super.apply(this, arguments); } return _possibleConstructorReturn(this, result); }; }

function _isNativeReflectConstruct() { if (typeof Reflect === "undefined" || !Reflect.construct) return false; if (Reflect.construct.sham) return false; if (typeof Proxy === "function") return true; try { Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function () {})); return true; } catch (e) { return false; } }

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.regexpCode = exports.getProperty = exports.safeStringify = exports.stringify = exports.strConcat = exports.addCodeArg = exports.str = exports._ = exports.nil = exports._Code = exports.Name = exports.IDENTIFIER = exports._CodeOrName = void 0;

var _CodeOrName = function _CodeOrName() {
  _classCallCheck(this, _CodeOrName);
};

exports._CodeOrName = _CodeOrName;
exports.IDENTIFIER = /^[a-z$_][a-z$_0-9]*$/i;

var Name = /*#__PURE__*/function (_CodeOrName2) {
  _inherits(Name, _CodeOrName2);

  var _super = _createSuper(Name);

  function Name(s) {
    var _this;

    _classCallCheck(this, Name);

    _this = _super.call(this);
    if (!exports.IDENTIFIER.test(s)) throw new Error("CodeGen: name must be a valid identifier");
    _this.str = s;
    return _this;
  }

  _createClass(Name, [{
    key: "toString",
    value: function toString() {
      return this.str;
    }
  }, {
    key: "emptyStr",
    value: function emptyStr() {
      return false;
    }
  }, {
    key: "names",
    get: function get() {
      return _defineProperty({}, this.str, 1);
    }
  }]);

  return Name;
}(_CodeOrName);

exports.Name = Name;

var _Code = /*#__PURE__*/function (_CodeOrName3) {
  _inherits(_Code, _CodeOrName3);

  var _super2 = _createSuper(_Code);

  function _Code(code) {
    var _this2;

    _classCallCheck(this, _Code);

    _this2 = _super2.call(this);
    _this2._items = typeof code === "string" ? [code] : code;
    return _this2;
  }

  _createClass(_Code, [{
    key: "toString",
    value: function toString() {
      return this.str;
    }
  }, {
    key: "emptyStr",
    value: function emptyStr() {
      if (this._items.length > 1) return false;
      var item = this._items[0];
      return item === "" || item === '""';
    }
  }, {
    key: "str",
    get: function get() {
      var _a;

      return (_a = this._str) !== null && _a !== void 0 ? _a : this._str = this._items.reduce(function (s, c) {
        return "".concat(s).concat(c);
      }, "");
    }
  }, {
    key: "names",
    get: function get() {
      var _a;

      return (_a = this._names) !== null && _a !== void 0 ? _a : this._names = this._items.reduce(function (names, c) {
        if (c instanceof Name) names[c.str] = (names[c.str] || 0) + 1;
        return names;
      }, {});
    }
  }]);

  return _Code;
}(_CodeOrName);

exports._Code = _Code;
exports.nil = new _Code("");

function _(strs) {
  var code = [strs[0]];
  var i = 0;

  for (var _len = arguments.length, args = new Array(_len > 1 ? _len - 1 : 0), _key = 1; _key < _len; _key++) {
    args[_key - 1] = arguments[_key];
  }

  while (i < args.length) {
    addCodeArg(code, args[i]);
    code.push(strs[++i]);
  }

  return new _Code(code);
}

exports._ = _;
var plus = new _Code("+");

function str(strs) {
  var expr = [safeStringify(strs[0])];
  var i = 0;

  for (var _len2 = arguments.length, args = new Array(_len2 > 1 ? _len2 - 1 : 0), _key2 = 1; _key2 < _len2; _key2++) {
    args[_key2 - 1] = arguments[_key2];
  }

  while (i < args.length) {
    expr.push(plus);
    addCodeArg(expr, args[i]);
    expr.push(plus, safeStringify(strs[++i]));
  }

  optimize(expr);
  return new _Code(expr);
}

exports.str = str;

function addCodeArg(code, arg) {
  if (arg instanceof _Code) code.push.apply(code, _toConsumableArray(arg._items));else if (arg instanceof Name) code.push(arg);else code.push(interpolate(arg));
}

exports.addCodeArg = addCodeArg;

function optimize(expr) {
  var i = 1;

  while (i < expr.length - 1) {
    if (expr[i] === plus) {
      var res = mergeExprItems(expr[i - 1], expr[i + 1]);

      if (res !== undefined) {
        expr.splice(i - 1, 3, res);
        continue;
      }

      expr[i++] = "+";
    }

    i++;
  }
}

function mergeExprItems(a, b) {
  if (b === '""') return a;
  if (a === '""') return b;

  if (typeof a == "string") {
    if (b instanceof Name || a[a.length - 1] !== '"') return;
    if (typeof b != "string") return "".concat(a.slice(0, -1)).concat(b, "\"");
    if (b[0] === '"') return a.slice(0, -1) + b.slice(1);
    return;
  }

  if (typeof b == "string" && b[0] === '"' && !(a instanceof Name)) return "\"".concat(a).concat(b.slice(1));
  return;
}

function strConcat(c1, c2) {
  return c2.emptyStr() ? c1 : c1.emptyStr() ? c2 : str(_templateObject || (_templateObject = _taggedTemplateLiteral(["", "", ""])), c1, c2);
}

exports.strConcat = strConcat; // TODO do not allow arrays here

function interpolate(x) {
  return typeof x == "number" || typeof x == "boolean" || x === null ? x : safeStringify(Array.isArray(x) ? x.join(",") : x);
}

function stringify(x) {
  return new _Code(safeStringify(x));
}

exports.stringify = stringify;

function safeStringify(x) {
  return JSON.stringify(x).replace(/\u2028/g, "\\u2028").replace(/\u2029/g, "\\u2029");
}

exports.safeStringify = safeStringify;

function getProperty(key) {
  return typeof key == "string" && exports.IDENTIFIER.test(key) ? new _Code(".".concat(key)) : _(_templateObject2 || (_templateObject2 = _taggedTemplateLiteral(["[", "]"])), key);
}

exports.getProperty = getProperty;

function regexpCode(rx) {
  return new _Code(rx.toString());
}

exports.regexpCode = regexpCode;